'use client';

import { markImpersonationSession } from '@/domains/common/impersonation.client';

// Always-visible bar shown while a back-office admin is impersonating a user, so
// no action is ever taken as that user without it being obvious. "Exit" logs the
// impersonation session out (back to /login → back-office).
export function ImpersonationBanner({ email }: { email: string }): React.ReactElement {
  markImpersonationSession();
  return (
    <div className="sticky top-0 z-[100] flex shrink-0 items-center justify-center gap-3 bg-amber px-4 py-1.5 text-[12.5px] font-medium text-black">
      <span>
        Impersonating <strong>{email}</strong>
      </span>
      <a href="/api/auth/logout" className="underline underline-offset-2 hover:opacity-80">
        Exit impersonation
      </a>
    </div>
  );
}
